<template>
  <div class="cover-type">
    <div class="clearfix">
      <div class="pull-left">
        <label>{{$t('cover.labelCoverType')}}</label>
        <div class="text-mini text-muted">點擊選擇封面</div>
      </div>
      <div class="pull-right" v-if="selected?.upload">
        <button class="btn btn-white" @click="design.cover.imageUrl = ''" v-if="design.cover.imageUrl">
          恢復原圖
        </button>
        <uploader @change="uploadCover" fileId="cover-input" :class="{disabled: uploading}">
          <button class="btn secondary" :class="{disabled: uploading}">
            <template v-if="uploading">
              <i class="fa fa-spinner fa-spin"></i>
              上傳中...
            </template>
            <template v-else>
              <i class="fa fa-photo"></i>
              {{$t('cover.labelButtonUpload')}}
            </template>
          </button>
        </uploader>
      </div>
    </div>

    <div class="cover-types">
      <div v-for="(item, index) in coverConfig" :key="index" class="cover-type-item" @click="selectCover(item)">
        <cover-holder :src="getCoverUrl(item.cover)" :height="coverHeight"
                      :selected="design.template === item.name">
          <div class="style-tag" :class="{primary: item.new}" v-if="item.upload || item.new">
            <i class="fa fa-image" v-if="!item.new"/>
            <strong class="text-mini" v-else>New</strong>
          </div>
        </cover-holder>
      </div>
    </div>
  </div>
</template>

<script>
import CoverHolder from '@/components/CoverHolder.vue'
import api from '@/api'

export default {
  name: 'cover-type',
  components: { CoverHolder },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      uploading: false,
      coverConfig: [
        {
          name: 'cover-psb-17',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-17',
          upload: true,
          color: false,
          new: new Date() < new Date('2026/04/01')
        },
        {
          name: 'cover-psb-16',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-16',
          upload: false,
          color: false,
          new: new Date() < new Date('2026/04/01')
        },
        {
          name: 'cover-psb-15',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-15',
          upload: false,
          color: false,
          new: new Date() < new Date('2026/04/01')
        },
        {
          name: 'cover-psb-12',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-12?size=320',
          upload: true,
          color: false,
          new: false
        },
        {
          name: 'cover-psb-13',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-13?size=320',
          upload: true,
          color: false,
          new: false
        },
        {
          name: 'cover-psb-14',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-14?size=320',
          upload: true,
          color: false,
          new: false
        },
        {
          name: 'cover-psb-1',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-1?size=320',
          upload: true,
          color: true
        },
        {
          name: 'cover-psb-2',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-2?size=320',
          upload: true,
          color: true
        },
        {
          name: 'cover-psb-3',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-3?size=320',
          upload: true,
          color: true
        },
        {
          name: 'cover-psb-4',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-4?size=320',
          upload: true,
          color: true
        },
        {
          name: 'cover-psb-5',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-5?size=320',
          upload: true,
          color: true
        },
        {
          name: 'cover-psb-11',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-11?size=320',
          upload: false,
          color: false,
          new: false
        },
        {
          name: 'cover-psb-6',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-6?size=320',
          upload: false
        },
        {
          name: 'cover-psb-7',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-7?size=320',
          upload: false
        },
        {
          name: 'cover-psb-8',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-8?size=320',
          upload: false
        },
        {
          name: 'cover-psb-9',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-9?size=320',
          upload: false
        },
        {
          name: 'cover-psb-10',
          cover: 'https://canvas.xinshu.me/generate/cover-psb-10?size=320',
          upload: false
        }
      ],
      coverHeight: 141.1
    }
  },
  computed: {
    design () {
      return this.value
    },
    selected () {
      const name = this.design.template.replace('type-', 'cover-psb-')
      return this.coverConfig.find(i => i.name === name)
    }
  },
  methods: {
    selectCover (item) {
      this.design.template = item.name
    },
    getCoverUrl (cover) {
      const { title, author } = this.design
      const url = new URL(cover)
      url.searchParams.set('title', title)
      url.searchParams.set('author', author)
      return url.toString()
    },
    async uploadCover (files) {
      try {
        let file = files[0]
        const formData = new window.FormData()
        if (!file) {
          return
        }
        file = file.source || file // 判断是否经过 FileReader 处理
        const { size } = file
        if (size >= 1000 * 1000 * 10) { // 提醒过大图片尺寸
          this.$toast({
            message: '圖片尺寸過大，请耐心等待'
          })
        }
        this.uploading = true
        formData.append('image', file)
        const data = await api.uploadImage(formData)
        let { origin, hostname } = window.location
        this.uploading = false
        if (!data || data.errors) {
          this.$toast({
            message: '上傳錯誤，請重新上傳'
          })
          return
        }

        if (hostname === 'localhost' || /\d/g.test(origin)) {
          origin = 'https://ipastbook.com'
        }
        data.image = /http?s:/.test(data.image) ? data.image : `${origin}${data.image}`
        this.design.cover.imageUrl = data.image
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style lang="scss">

.cover-type {
  .cover-types {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    margin-top: .5rem;
  }

  .row {
    flex: 1;
  }

  &-item {
    width: 25%;
    flex: 0 0 25%;
    position: relative;
    padding: 5px;
    overflow: hidden;
    cursor: pointer;

    &.active {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, .3);
      }
    }
  }
}
</style>
